const NameAvatarComponent = ({
  firstName,
  lastName,
  heightWidth,
  fromTopBar = false,
  fontSize = "16px",
  redBorder = null,
  color = "white",
  backgroundColor = null,
  shape = "circle",
  className=undefined          // <-- NEW prop
}) => {
  let totalInitials = "";
  const firstLetter = firstName && firstName?.[0]?.toUpperCase();
  const lastLetter =
    lastName && lastName.length > 0 ? lastName?.[0]?.toUpperCase() : "";

  totalInitials =
    (firstLetter ? firstLetter : "") +""+ (lastLetter ? lastLetter : "");

  return (
    <div
      style={{
        minHeight: `${heightWidth}px`,
        minWidth: `${heightWidth}px`,
        background: fromTopBar ? "#E1EFFE" : backgroundColor || "#3F83F8",
        fontSize: fontSize,
        color: color,
        letterSpacing: "1px",
        border: redBorder ? "" : "2.5px solid #C3DDFD",
        borderRadius: shape === "square" ? "4px" : "50%", // <-- CONTROL SHAPE
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
      className={className ? className :"initialBox"}
    >
      {totalInitials}
    </div>
  );
};

export default NameAvatarComponent;
